module.exports = __webpack_public_path__ + "73cc27e20bed3ecb7332850240298b37.svg";